package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.Green300
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ItineraryServiceStatus(
    status: ItineraryServiceModel.Status?,
    suffixIconRes: String? = null,
    modifier: Modifier = Modifier,
) {
    val text = remember(status) {
        when (status) {
            null -> "Status"
            ItineraryServiceModel.Status.Ready -> "Ready"
            ItineraryServiceModel.Status.Confirmed -> "Confirmed"
            ItineraryServiceModel.Status.POSent -> "PO sent"
            ItineraryServiceModel.Status.TOChange -> "To change"
            ItineraryServiceModel.Status.Cancelled -> "Cancelled"
            ItineraryServiceModel.Status.Completed -> "Completed"
        }
    }

    val esColorScheme = MaterialTheme.esColorScheme
    val color = remember(status) {
        when (status) {
            null -> Color.White
            ItineraryServiceModel.Status.Ready -> esColorScheme.tinted
            ItineraryServiceModel.Status.Confirmed -> Green300
            ItineraryServiceModel.Status.POSent -> esColorScheme.tintedPressed
            ItineraryServiceModel.Status.TOChange -> esColorScheme.bgWarning
            ItineraryServiceModel.Status.Cancelled -> Color.Red.copy(alpha = 0.5f)
            ItineraryServiceModel.Status.Completed -> esColorScheme.bgSuccess
        }
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        modifier = modifier
            .background(color, CircleShape)
            .padding(
                vertical = EsConstants.StatusDropdownVerticalPadding,
                horizontal = EsConstants.StatusDropdownHorizontalPadding,
            ),
    ) {
        Text(
            text = text,
            maxLines = 1,
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p2Medium14,
        )

        suffixIconRes?.let {
            EsLargeIcon(
                res = it,
                tint = MaterialTheme.esColorScheme.iconPrimary,
            )
        }
    }
}